module.exports = __webpack_public_path__ + "img/goldregen-2020-085.efc6ec51.jpg";